import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { paths } from 'src/routes/paths';

import { useBoolean } from 'src/hooks/use-boolean';

import Main from '../main';
import Header from '../header';
import NavVertical from './nav-vertical';
import { useNavData } from './config-navigation';

// ----------------------------------------------------------------------

export default function EngagementDashboardLayout({ children }) {
  const nav = useBoolean();
  const navData = useNavData();
  const renderNavVertical = (
    <NavVertical
      openNav={nav.value}
      onCloseNav={nav.onFalse}
      navData={navData}
      moduleType="engagement"
      itemHref={paths.entity.modules.engagement.dashboard.root}
    />
  );

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        {renderNavVertical}

        <Main>{children}</Main>
      </Box>
    </>
  );
}

EngagementDashboardLayout.propTypes = {
  children: PropTypes.node,
};
